'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module3App3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module3,
    app: state.moduleData.data.module3.app3
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3App3, _Component);

  function Module3App3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3App3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3App3.__proto__ || (0, _getPrototypeOf2.default)(Module3App3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 3,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'The P\'s and C\'s: a helpful framework for feeding children'
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module3App3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Helps ',
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              'to divide responsibilities between children and adults'
            ),
            ' - this can help to take the stress out of mealtimes.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'The P\'s: Parents are encouraged to plan, prepare and provide'
          ),
          _react2.default.createElement(
            'h4',
            null,
            '1. Plan the type of foods you want to buy and have in your home'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Plan when the meals and snacks will be offered'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Plan where foods will be eaten'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Plan what rules should be followed in your home'
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            '2. Prepare healthy food options for mealtimes and snack times'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Prepare options that include lots of fruit and vegetables'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Where possible, ask your children to help you with cooking. Getting children involved will increase the likelihood that they will enjoy and eat healthy foods'
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            '3. Provide healthy food options in a positive way'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'It is your responsibility as a parent to allow your child the choice of',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  ' what and how much '
                ),
                ' they will eat from what you provide, within reasonable limits. This doesn\'t mean they have the choice to replace healthy options with less healthy ones'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'For example, they can\'t choose chips instead of vegetables'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'However, ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'providing discrete options eg. "Do you want your carrots round or long"'
                ),
                ' can help children become more interested in their food by being involved in decision-making in a small way'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Children have a choice within the planned, prepared, and provided options'
              )
            )
          ),
          _react2.default.createElement(
            'h3',
            null,
            'The C\'s: Children are encouraged to choose whether, what and how much to eat'
          ),
          _react2.default.createElement(
            'h4',
            null,
            '1. Choose whether or not to eat'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'When meals and snacks are provided to children as part of a regular schedule, it\'s OK for them to choose not to eat as you can be confident that ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'they won\'t go hungry.'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'It is important that the child knows that choosing not to eat at one meal or snack time means they ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'won\'t have the option to eat again until the next regularly scheduled meal or snack'
                )
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            '2. Choose what to eat from a variety of healthy food options'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Encouraging your child to ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'participate in planning and preparing healthy foods'
                ),
                ' will increase the chances that the child will make',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  ' healthy choices in the future'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'If your child really likes a \'sometimes\' food, only offer that food occasionally and as a small serving'
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            '3. Choose how much to eat at scheduled mealtimes and snacks'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'When parents put food on their child\'s plate, they often put on more than the child can eat'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Make sure you ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'serve small amounts appropriate for a child of that age'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Remove any television, computer, tablet, phone or gaming distractions as they can cause children to eat too little or too much of the food provided, depending on the circumstances'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Under this framework, ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'there is no pressure for a child to \'clean their plate\'. '
                ),
                'If a child chooses ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'not to finish their meal, then they will have to wait until the next scheduled meal or snack before they can eat again'
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module3App3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module3App3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/App/App3.js
// module id = 1198
// module chunks = 0